import { forwardRef, useEffect, useRef, useImperativeHandle, useMemo } from 'react';
import mapboxgl from '!mapbox-gl';  // eslint-disable-line import/no-webpack-loader-syntax
import useMap from '@components/operatorLobby/useMap'
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions'
import '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css';

function NavigationMap ({ vehicle, isReadOnly }, ref) {
    const { mapRef, mapContainerRef } = useMap([vehicle]);
    const directionControlRef = useRef();

    useImperativeHandle(ref, () => ({
        getOrigin: () => {
            const geometry = directionControlRef.current.getOrigin().geometry;
            if(geometry) {
                return geometry.coordinates;
            } else {
                return [0,0];
            }
        },
        getDestination: () => {
            const geometry = directionControlRef.current.getDestination().geometry;
            if(geometry) {
                return geometry.coordinates;
            } else {
                return [0,0];
            }
        },
    }));

    // eslint-disable-next-line
    const missionPlan = useMemo(() => vehicle.missionPlan, [JSON.stringify(vehicle.missionPlan)]);

    useEffect(() => {
        const map = mapRef.current;
        const directionControl = new MapboxDirections({
            accessToken: mapboxgl.accessToken,
            interactive: !isReadOnly,
            controls: {
                inputs: !isReadOnly,
                profileSwitcher: false,
            },
            unit: 'metric',
            profile: 'mapbox/driving'
        });

        map.addControl(directionControl, 'top-left');

        map.on('load', () => {
            directionControl.setOrigin(missionPlan.origin);
            directionControl.setDestination(missionPlan.destination);
        });

        directionControlRef.current = directionControl;

        return () => {
            map.removeControl(directionControl);
        };

    }, [missionPlan, isReadOnly, mapRef]);

    return <div ref={mapContainerRef} className="map-container"></div>;
}

export default forwardRef(NavigationMap);
